import { Checkbox, Table } from "antd";
import React, { useState } from "react";

type Props = {
  newRows: any[];
  columns: any[];
  onCheckedHeader: (checked: boolean) => void;
};

const ExcelTablePreview = ({ newRows, columns, onCheckedHeader }: Props) => {
  const [sourceData, setsourceData] = useState(newRows);

  const [displayData, setDisplayData] = useState(newRows);
  const [pageSize, setPageSize] = useState(10);
  const [current, setCurrent] = useState(1);
  console.log("newRows", newRows);
  console.log("newRows=>columns", columns);
  return (
    <>
      <Table
        dataSource={displayData}
        columns={columns.filter((e) => e.key !== "operation")}
        scroll={{ x: 1500 - 1000, y: 500 }}
        pagination={{
          pageSize: pageSize,
          onShowSizeChange: (current, size) => {
            setPageSize(size);
          },
        }}
      />
    </>
  );
};

export default ExcelTablePreview;
